const initialState = {
  inboxAgentList: [],
  loading: false,
  error: null,
  inboxAgentListByRole: [],
  loadingByRole: false,
  errorByRole: null
};

export default function inboxAgentsReducer(state = initialState, action) {
  switch (action.type) {
    case 'INBOX_AGENTS_LOADING':
      return { ...state, loading: true, error: null };
    case 'SET_INBOX_AGENTS_DATA':
      return { ...state, inboxAgentList: action.data.agents || [], loading: false, error: null };
    case 'INBOX_AGENTS_FAILURE':
      return { ...state, loading: false, error: action.err };
    case 'INBOX_AGENTS_ALREADY_LOADED':
      return { ...state, loading: false };

    // Estados para agentes por rol
    case 'INBOX_AGENTS_BY_ROLE_LOADING':
      return { ...state, loadingByRole: true, errorByRole: null };
    case 'SET_INBOX_AGENTS_BY_ROLE_DATA':
      return { ...state, inboxAgentListByRole: action.data.agents || [], loadingByRole: false, errorByRole: null };
    case 'INBOX_AGENTS_BY_ROLE_FAILURE':
      return { ...state, loadingByRole: false, errorByRole: action.err };
    case 'INBOX_AGENTS_BY_ROLE_ALREADY_LOADED':
      return { ...state, loadingByRole: false };

    default:
      return state;
  }
}
